import { Route, Routes, Navigate } from 'react-router-dom';

import { Login } from './Login';
import { Register } from './Register';
import { ForgotPassword } from './ForgotPassword';
import { AccountCreatedSuccess } from './AccountCreatedSuccess';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="register" element={<Register />} />
      {/* <Route path="register/success" element={<AccountCreatedSuccess />} /> */}
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
};
